import { clamp } from 'lodash'
import { ReportMetricRankedItem } from '../../content/REPORT_METRIC_TEXTS'

const SubPageMetric = (props: ReportMetricRankedItem) => {
  return (
    <div>
      <div style={{ padding: 30 }}>
        <p className={'subtitle'}>{props?.metric_name}</p>
        <p
          dangerouslySetInnerHTML={{ __html: props.metric_description }}
          className={'description-sub'}
        ></p>
        <ProgressLineDetail {...props} />
        <p className={'text-line'}>“What does my value mean?”</p>
        <p
          dangerouslySetInnerHTML={{ __html: props.what_value_means || '' }}
          className={'description-sub'}
        ></p>
      </div>
      <div style={{ padding: 30, backgroundColor: '#EFEFEF' }}>
        <p
          className={'description-sub'}
          style={{ textTransform: 'uppercase', fontSize: '0.7rem' }}
        >
          Metabolic expert recommendation
        </p>
        <p dangerouslySetInnerHTML={{ __html: props.metabolic_recommendation || '' }}></p>
      </div>
      <div style={{ padding: 30 }}>
        <p>“Why it's important to pay attention?”</p>
        <p
          dangerouslySetInnerHTML={{ __html: props.why_its_important || '' }}
          className={'description-sub'}
        ></p>
      </div>
      <hr />
    </div>
  )
}

const ProgressLineDetail = (props: ReportMetricRankedItem) => {
  const getPercentWidth = (num: number) => {
    const resNum = (100 * (num - props.min)) / (props.max - props.min)
    return clamp(resNum, 1, 100)
  }
  const percentValue = getPercentWidth(props.real_value)
  const percentTarget = getPercentWidth(props.target_value)
  const unitTarget = props.target_value > props.min ? '<' : '>'

  return (
    <div>
      <div>
        <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          <p className={'description-sub'}>{props.min}</p>
          <p className={'description-sub'}>{props.max}</p>
        </div>
        {/*OUTER LINE*/}
        <div style={{ width: '100%', height: 9, backgroundColor: 'rgba(33,33,33,0.04)', borderRadius: 10 }}>
          {/*INNER LINE*/}
          <div
            style={{
              height: 9,
              width: `${percentValue}%`,
              backgroundColor: props.color,
              borderRadius: 10,
              position: 'relative',
            }}
          >
            {/*<div style={{*/}
            {/*	width: 1.5,*/}
            {/*	height: 40,*/}
            {/*	backgroundColor: '#ccc',*/}
            {/*	borderRadius: 2,*/}
            {/*	marginLeft: `${percentTarget}%`,*/}
            {/*	position: 'absolute',*/}
            {/*	top: -32,*/}
            {/*	zIndex: 0*/}
            {/*}}>*/}
            {/*</div>*/}
            {/*<p style={{*/}
            {/*	width: 200,*/}
            {/*	height: 50,*/}
            {/*	marginLeft: `${percentTarget}%`,*/}
            {/*	position: 'absolute',*/}
            {/*	top: -70,*/}
            {/*	zIndex: 0,*/}
            {/*	fontSize: '0.8rem',*/}
            {/*}} className={'description-sub'}>Target value ({unitTarget}{props.target_value})</p>*/}
            {/*DISPLAY*/}
            <div
              style={{
                width: 80,
                height: 35,
                borderRadius: 20,
                backgroundColor: props.color,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginLeft: 'auto',
                position: 'relative',
                marginRight: -10,
                top: -13,
              }}
            >
              <b>
                <p style={{ padding: 0, margin: 0, fontSize: '0.9rem', fontWeight: 'bold' }}>{props.real_value}</p>
              </b>
            </div>
          </div>
        </div>
      </div>
      <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        <p className={'description-sub'}>Very poor</p>
        <p className={'description-sub'}>Very good</p>
      </div>
    </div>
  )
}

export default SubPageMetric
